
function Title(props) {
  return <h1 className={`font-bold text-lg ${props?.className}`}>{props?.title}</h1>;
}

export default Title;
